import ActiveClockIcon from 'public/assets/icons/active-clock.svg';
import AdultIcon from 'public/assets/icons/adult.svg';
import ArrowDownIcon from 'public/assets/icons/arrow-down.svg';
import ArrowLeftIcon from 'public/assets/icons/arrow-left.svg';
import BabyIcon from 'public/assets/icons/baby.svg';
import CalendarIcon from 'public/assets/icons/calendar.svg';
import CallCallingIcon from 'public/assets/icons/call-calling.svg';
import CallIcon from 'public/assets/icons/call.svg';
import ChevronLeftIcon from 'public/assets/icons/chevron-left.svg';
import ChildIcon from 'public/assets/icons/child.svg';
import ClockIcon from 'public/assets/icons/clock.svg';
import DirectUpIcon from 'public/assets/icons/direct-up.svg';
import DepartureIcon from 'public/assets/icons/direction.svg';
import EditIcon from 'public/assets/icons/edit.svg';
import HomeIcon from 'public/assets/icons/home.svg';
import SmallKakaotalkIcon from 'public/assets/icons/kakaotalk.svg';
import LocationIcon from 'public/assets/icons/location.svg';
import LockIcon from 'public/assets/icons/lock.svg';
import LoginIcon from 'public/assets/icons/login.svg';
import LogoutIcon from 'public/assets/icons/logout.svg';
import MapIcon from 'public/assets/icons/map.svg';
import NotificationIcon from 'public/assets/icons/notification.svg';
import PercentageCircleIcon from 'public/assets/icons/percentage-circle.svg';
import Profile2UserIcon from 'public/assets/icons/profile-2user.svg';
import ProfileIcon from 'public/assets/icons/profile.svg';
import SmallWhatsappIcon from 'public/assets/icons/small-whatsapp.svg';
import TicketDiscountIcon from 'public/assets/icons/ticket-discount.svg';
import UserSquareIcon from 'public/assets/icons/user-square.svg';
import UserIcon from 'public/assets/icons/user.svg';
import ZaloIcon from 'public/assets/icons/zalo.svg';
import OpenMapIcon from 'public/assets/icons/ic_open_map.svg';
import UsaFlagIcon from 'public/assets/icons/flags/usa-flag.svg';
import VnFlagIcon from 'public/assets/icons/flags/vietnam-flag.svg';
import KoreaFlagIcon from 'public/assets/icons/flags/korea-flag.svg';
import TripadvisorLogoIcon from 'public/assets/icons/tripadvisor-logo.svg';
import CalendarGreyIcon from 'public/assets/icons/calendar_grey.svg';
import ClockGreyIcon from 'public/assets/icons/clock_grey.svg';
import StartPickupIcon from 'public/assets/icons/tourPriceOptionTimeline/ic_start_pickup.svg';
import CheckpointIcon from 'public/assets/icons/tourPriceOptionTimeline/ic_checkpoint.svg';
import CloseIcon from 'public/assets/icons/close.svg';

export {
  ActiveClockIcon,
  AdultIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  BabyIcon,
  CalendarIcon,
  CallCallingIcon,
  CallIcon,
  ChevronLeftIcon,
  ChildIcon,
  ClockIcon,
  DepartureIcon,
  DirectUpIcon,
  EditIcon,
  HomeIcon,
  LocationIcon,
  LockIcon,
  LoginIcon,
  LogoutIcon,
  MapIcon,
  NotificationIcon,
  PercentageCircleIcon,
  Profile2UserIcon,
  ProfileIcon,
  SmallKakaotalkIcon,
  SmallWhatsappIcon,
  TicketDiscountIcon,
  UserIcon,
  UserSquareIcon,
  ZaloIcon,
  OpenMapIcon,
  UsaFlagIcon,
  VnFlagIcon,
  KoreaFlagIcon,
  TripadvisorLogoIcon,
  CalendarGreyIcon,
  ClockGreyIcon,
  StartPickupIcon,
  CheckpointIcon,
  CloseIcon
};
